import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '../../pipes/translate.pipe';

/**
 * Content shown when a plan's asset/custom-form hard cap has been reached.
 * Rendered inside a ModalService modal -- the "Upgrade Plan" / "Buy Form Pack"
 * action buttons live in the modal's own footer config (see checkPoints.component.ts
 * / forms.component.ts), not in this component.
 */
@Component({
  selector: 'app-upsell-dialog',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './upsell-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './upsell-dialog.component.css',
})
export class UpsellDialogComponent {
  @Input() limitType: 'asset' | 'customForm' = 'asset';
  @Input() planName = '';
}
